import React, { useEffect } from "react";
import { Button } from "@mui/material";
import { useForm, useFieldArray } from "react-hook-form";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import QuestionItem from "./QuestionItem";
import { useQuestionsApi } from "./useQuestions";

const QuestionForm = ({ onSubmit, editData, setEditData, categories }) => {
const sensors = useSensors(
  useSensor(PointerSensor, {
    activationConstraint: {
      distance: 8,
    },
  }),
  useSensor(TouchSensor, {
    activationConstraint: {
      delay: 150,
      tolerance: 5,
    },
  })
);

  const {
    control,
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { questions: [] },
  });

  const { fields, append, remove, move } = useFieldArray({
    control,
    name: "questions",
  });

  useEffect(() => {
    if (editData) {
      reset({
        questions: editData.questions.map((q) => ({
          ...q,
          categoryId: q.categoryId || "",
        })),
      });
    }
  }, [editData, reset]);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    const oldIndex = fields.findIndex((f) => f.id === active.id);
    const newIndex = fields.findIndex((f) => f.id === over.id);

    move(oldIndex, newIndex); //  only UI reorder
  };
  return (
    <>
      <Button
        variant="contained"
        onClick={() => {
          setEditData(null);
          reset({ questions: [] });

          append({
            questionText: "",
            answerText: "",
            questionId: 0,
            category: "",
          });
        }}
      >
        Add Question
      </Button>

      <form
        onSubmit={handleSubmit(async (data) => {
          const updated = data.questions.map((q, i) => ({
            ...q,
            position: i + 1,
          }));

          for (let i = 0; i < updated.length; i++) {
            await onSubmit(updated[i]);
          }

          reset({ questions: [] });
        })}
      >
        <DndContext
           sensors={sensors}
  collisionDetection={closestCenter}
onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={fields.map((f) => f.id)}
            strategy={verticalListSortingStrategy}
          >
            {fields.map((field, index) => (
              <QuestionItem
                key={field.id}
                id={field.id}
                index={index}
                register={register}
                control={control}
                remove={remove}
                categories={categories}
                errors={errors}
              />
            ))}
          </SortableContext>
        </DndContext>

        {fields.length > 0 && (
          <Button type="submit" variant="contained" color="success">
            {editData ? "Update" : "Save"}
          </Button>
        )}
      </form>
    </>
  );
};

export default QuestionForm;
